import { h } from 'preact';
import MaterialComponent from '../Base/MaterialComponent';
import Icon from '../Icon';
import generateThemeClass from '../themeUtils/generateThemeClass';
export class FabIcon extends Icon {
    constructor() {
        super(...arguments);
        this.componentName = 'fab__icon';
    }
}
export class Fab extends MaterialComponent {
    constructor() {
        super(...arguments);
        this.componentName = 'fab';
        this.mdcProps = ['mini', 'exited'];
        this.themeProps = ['primary', 'secondary'];
    }
    materialDom(props) {
        const classNames = [];
        this.themeProps.forEach(themeProp => {
            if (themeProp in props && props[themeProp] !== false) {
                classNames.push(generateThemeClass(themeProp));
            }
        });
        return (h("button", Object.assign({ ref: this.setControlRef }, props, { className: classNames.join(' ') }), props.children));
    }
}
export default class default_1 extends Fab {
}
default_1.Icon = FabIcon;
//# sourceMappingURL=index.js.map